import React, { useContext, useEffect } from 'react'
import { Box, Divider, Select, Text } from '@deseretbook/react-ui'
import PageLayout from '../layouts/DefaultLayout'
import ErrorComponent from '../components/ErrorComponent'
import MediaList from '../components/media/mediaList/MediaList'
import LoadingIndicator from '../components/media/loadingIndicator/LoadingIndicator'
import Paginator from '../components/buttons/Paginator'
import { SearchContext } from '../components/search/SearchProvider'
import BreadcrumbButton from '../components/buttons/BreadcrumbButton'
import FilterOptions from '../components/media/filterOptions/FilterOptions'
import { TABS } from '../components/media/constants'
import { useMediaQuery } from '@deseretbook/react-utils'

/**
 * Search page
 *
 * @returns {function} Component
 */
const SearchPage = () => {
  const {
    results,
    query,
    tab,
    toggleTab,
    setQuery,
    error,
    isLoading,
    isLoadingAll,
    pagination,
    itemsPerPage,
    setItemsPerPageCount,
    totalResults,
    updateMedia,
  } = useContext(SearchContext)

  const isDesktopOrLarger = useMediaQuery(1024)
  const isTabletOrLarger = useMediaQuery(960)
  const isTabletOrSmaller = useMediaQuery({ maxWidth: 830 })

  const { updatePage, totalPages, currentPage } = pagination

  useEffect(() => {
    // Extract query parameter from URL
    const params = new URLSearchParams(window.location.search)
    const urlQuery = params.get('q')

    // Check if query parameter exists and is not empty
    if (urlQuery && urlQuery.trim() !== '' && query !== urlQuery) {
      // Set the query and trigger search
      setQuery(urlQuery)
    }
    // eslint-disable-next-line
  }, [location.search, setQuery])

  const showLoadingIndicator = isLoading || (currentPage > 1 && isLoadingAll && !results.length)

  return (
    <PageLayout>
      {error && <ErrorComponent error={error} />}
      <Box alignItems="center" justifyContent="space-between" marginTop={1}>
        <Box alignItems="center">
          {isTabletOrLarger && <BreadcrumbButton />}
          <FilterOptions
            title="Search Results"
            tab={tab}
            tabs={[
              { title: 'All', value: TABS.all },
              { title: 'Audiobooks', value: TABS.audiobook },
              { title: 'eBooks', value: TABS.ebook },
            ]}
            toggleTab={toggleTab}
          />
        </Box>
        <Box
          alignItems={isTabletOrSmaller ? 'flex-end' : 'center'}
          isColumn={isTabletOrSmaller}
          style={{ flexWrap: 'wrap' }}
        >
          {!showLoadingIndicator ? (
            <Text
              style={{
                fontFamily: 'Roboto, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                color: '#000000A6',
              }}
            >
              {totalResults} results
            </Text>
          ) : null}
        </Box>
      </Box>
      <Divider
        style={{ boxShadow: 'none', borderBottom: '1px solid #d7d7d7', marginBottom: '48px' }}
      />
      <Box style={{ width: isDesktopOrLarger ? '80%' : '100%', margin: '0 auto' }}>
        {showLoadingIndicator ? (
          <LoadingIndicator isRelative />
        ) : (
          <MediaList media={results} updateMedia={updateMedia} />
        )}
      </Box>

      {!showLoadingIndicator ? (
        <Box
          alignItems="center"
          justifyContent="space-between"
          style={{ margin: '1rem 0', padding: '1rem 0' }}
        >
          <Box alignItems="center">
            Show
            <Select
              style={{ padding: '0 2rem 0 0.5rem' }}
              value={itemsPerPage}
              options={[10, 20, 50]}
              removeHint
              fieldProps={{ style: { margin: '0 0.5rem' } }}
              onChange={(e) => {
                if (!!e.target.value) {
                  setItemsPerPageCount(e.target.value)
                }
              }}
            />
            items per page
          </Box>
          <Box width={22}>
            <Paginator
              currentPage={currentPage}
              totalPages={totalPages}
              setCurrentPage={updatePage}
            />
          </Box>
        </Box>
      ) : null}
    </PageLayout>
  )
}

export default SearchPage
